import { useTranslation } from '@thoughtspot/i18n';
import { Button } from '@thoughtspot/radiant-react/widgets/button';
import { Horizontal, Vertical, } from '@thoughtspot/radiant-react/widgets/layout';
import { Typography } from '@thoughtspot/radiant-react/widgets/typography';
import React from 'react';
import { V2TranslationKeys } from '../../constants';
import styles from './user-details-modal.module.scss';
import { UserListPanel, UserProfilePanel, } from './user-details-panels';
export const UserDetailsModal = ({ displayName, email, userId, metadataRows, listTitle, listItems, onClose, onEdit, }) => {
    const { t } = useTranslation();
    const title = t(V2TranslationKeys.USER_DETAILS_TITLE);
    return (React.createElement(Horizontal, { className: styles.userDetailsOverlay, vAlignContent: "center", "data-testid": "user-details-overlay", onClick: e => {
            if (e.target === e.currentTarget)
                onClose();
        } },
        React.createElement(Vertical, { role: "dialog", "aria-modal": "true", "aria-label": title, className: styles.userDetailsModal, "data-testid": "user-details-modal" },
            React.createElement(Vertical, { className: styles.userDetailsHeader },
                React.createElement(Typography, { variant: "modal-title", noMargin: true }, title)),
            React.createElement(Horizontal, { className: styles.userDetailsContent, grow: true },
                React.createElement(UserProfilePanel, { displayName: displayName, email: email, userId: userId, metadataRows: metadataRows }),
                React.createElement(UserListPanel, { title: listTitle, items: listItems })),
            React.createElement(Horizontal, { className: styles.userDetailsFooter, vAlignContent: "center", spacing: "c" },
                React.createElement(Button, { type: "secondary", text: t(V2TranslationKeys.EDIT), onClick: onEdit }),
                React.createElement(Button, { type: "primary", text: t(V2TranslationKeys.CLOSE), onClick: onClose })))));
};
//# sourceMappingURL=user-details-modal.js.map